import $ from 'jquery'
import { lockBody, unlockBody } from '../utils'
import 'parsleyjs'
import 'parsleyjs/src/i18n/fr'
import * as FilePond from 'filepond'
import fr_fr from 'filepond/locale/fr-fr.js';
import {Alert} from '../functions'

// eslint-disable-next-line no-undef
const object = vnObject

FilePond.setOptions(fr_fr);

$('.js-open-mobile-navigation').on('click', function () {
    $('.js-mobile-nav').animate({height: 'toggle'})
    lockBody()
})

$('.js-close-mobile-navigation').on('click', function () {
    $('.js-mobile-nav').animate({height: 'toggle'})
    unlockBody()
})

const savForm = $('.sav-form')

const attachments = FilePond.create(document.querySelector('.filepond-attachments'), {
    fileValidateTypeLabelExpectedTypes: 'Expects {allButLastType} or {lastType}',
});

const fileErrorAttachments = $('#js-filepond-attachments-error-container');
attachments.on('addfile', (event) => {
    fileErrorAttachments.html('')
});

attachments.on('removefile', (event) => {
    fileErrorAttachments.html(fileErrorAttachments.attr('data-error-message'))
});


if (savForm.length) {
    savForm.parsley().on('form:success', function () {
        savForm.attr('data-success', 'true')
    })

    savForm.parsley().on('form:error', function () {
        savForm.attr('data-success', 'false')
    })

    savForm.on('submit', function (e) {
        e.preventDefault()
        e.stopPropagation()

        const formData = new FormData(savForm[0])
        formData.append('action', 'vn_sav')
        formData.append('nonce', object.nonce)

        var pondFiles = attachments.getFiles();
        if ( pondFiles[0] ) {
            formData.append('attachments', pondFiles[0].file);
        }

        const $savForm = $(this)

        $.ajax({
            url: object.ajaxUrl,
            type: 'POST',
            dataType: 'JSON',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: () => {
                $savForm.addClass('sending')
                Alert('warning', object.formWait, false)
            },
            success: (res) => {
                $savForm.removeClass('sending')

                if (res.success && res.data.redirect) {
                    window.location = res.data.redirect
                }

                Alert(res.success, res.data.message)

                res.success && $savForm[0].reset()
            },
        })
    })
}
